import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/elements/buttons/primary';
// import fbIcon from 'assets/images/social-media/facebook-new.svg';
// import igIcon from 'assets/images/social-media/instagram.png';
// import twIcon from 'assets/images/social-media/twitter.svg';
// import snapIcon from 'assets/images/social-media/snapchat_icon.svg';
// import sharesomeIcon from 'assets/images/social-media/sharesome.svg';
// import tiktokIcon from 'assets/images/social-media/tiktok.png';
// import emailIcon from 'assets/images/email.svg';
// import shareIcon from 'assets/images/share.svg';
import Icon from 'common/components/elements/icons';
import './style.scss'
import { makeFbShareUrl,
   //  makeShareSomeShareUrl,
   makeSnapShareUrl, makeTweetableUrl } from 'common/utils/utils';
import { getNickName } from 'common/utils/helper';
import { getPhotosetById, getStoryById, getVideoById, initStoreById } from 'sites/api/MixApi';
import { useSelector } from 'react-redux';
import Loader from 'common/components/elements/loader/circle';

const  SnapchatIcon = () => {
   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         xmlnsXlink='http://www.w3.org/1999/xlink'
         enableBackground='new 0 0 1000 1000'
         version='1.1'
         viewBox='0 0 1000 1000'
         xmlSpace='preserve'
      >
         <path
            fill='#FFFC00'
            d='M500 1000c276.1 0 500-223.9 500-500S776.1 0 500 0 0 223.9 0 500s223.9 500 500 500z'
            className='st0'
         ></path>
         <defs>
            <path id='SVGID_1_' d='M232.7 249H767.4000000000001V751H232.7z'></path>
         </defs>
         <clipPath id='SVGID_2_'>
            <use overflow='visible' xlinkHref='#SVGID_1_'></use>
         </clipPath>
         <path
            fill='#FFF'
            d='M503.1 745.1c-1.4 0-2.7 0-3.9-.2-.9 0-1.8.2-2.7.2-31 0-50.8-14.1-70.1-27.7-13.2-9.5-25.9-18.2-40.5-20.7-7.1-1.2-14.5-1.8-21.2-1.8-12.5 0-22.3 2-29.4 3.4-4.3.9-8.2 1.6-11.1 1.6-3 0-6.2-.7-7.7-5.5-1.2-4.1-2.1-8.2-3-12.1-2.1-10-3.7-16.2-8-16.9-49.1-7.7-63.2-18-66.4-25.3-.4-1.1-.7-2.1-.7-3.2-.2-2.9 1.8-5.4 4.6-5.7 75.5-12.5 109.4-89.6 110.8-93 0-.2 0-.2.2-.4 4.6-9.3 5.5-17.5 2.7-24.1-5.2-12.1-22.1-17.7-33.2-21.1-2.7-.9-5.4-1.6-7.3-2.5-22.3-8.7-24.3-17.8-23.4-22.5 1.4-7.9 12-13.4 20.5-13.4 2.3 0 4.5.4 6.1 1.3 10 4.6 19.1 7.1 26.9 7.1 10.7 0 15.5-4.5 16.1-5.2-.4-5.2-.5-10.5-.9-15.9-2.3-35.7-5-80.1 6.2-105.4 33.9-75.8 105.6-81.7 126.8-81.7.5 0 9.3-.2 9.3-.2h1.3c21.2 0 93.1 5.9 127 81.9 11.2 25.3 8.6 69.8 6.2 105.4l-.2 1.6c-.4 5-.5 9.8-.9 14.5.5.5 4.8 4.6 14.6 5.2 7.5-.4 16.1-2.7 25.3-7.1 2.7-1.2 5.9-1.6 7.9-1.6 3.2 0 6.4.5 9.1 1.8h.2c7.7 2.7 12.5 8 12.7 13.6.2 5.2-3.9 13-23.6 20.9-2 .7-4.6 1.6-7.3 2.5-11.2 3.6-28 8.9-33.2 21.1-2.9 6.6-2 14.8 2.7 24.1 0 .2 0 .2.2.4 1.4 3.2 35.3 80.5 110.8 92.9 2.9.5 4.8 3 4.6 5.7 0 1.1-.4 2.1-.7 3.2-3 7.3-17.1 17.7-66.4 25.2-3.9.5-5.5 5.9-8 16.8-.9 3.9-1.8 7.8-3 12-1.1 3.6-3.2 5.2-7 5.2h-.5c-2.7 0-6.2-.5-11.1-1.4-8.4-1.6-17.7-3.2-29.4-3.2-7 0-14.1.5-21.2 1.8-14.8 2.5-27.3 11.2-40.5 20.7-19.4 13.6-39.4 27.7-70.3 27.7'
            className='st1'
            clipPath='url(#SVGID_2_)'
         ></path>
         <path
            d='M504.9 249h-10.5c-21.9 0-96.7 6.1-131.8 85.1-11.8 26.6-8.9 71.7-6.8 107.9.4 4.3.5 8.7.7 13-1.8 1.1-5.2 2.3-10.3 2.3-7 0-15.2-2.1-24.6-6.6-2.5-1.1-5.4-1.8-8.4-1.8-10.9 0-23.9 7.1-25.9 17.8-1.4 7.7 2 18.9 26.8 28.7 2.3.9 5 1.8 7.7 2.7 10.2 3.2 25.7 8.2 29.8 18 2.1 5.2 1.2 11.8-2.5 19.6 0 .2-.2.4-.2.5-1.4 3.2-34.1 77.6-106.5 89.6-5.5.9-9.6 5.9-9.3 11.6.2 1.6.5 3.4 1.2 5 5.5 12.7 28.4 22.1 70.3 28.5 1.4 2 2.9 8.6 3.7 12.7.9 3.9 1.8 8.2 3 12.5 1.2 4.3 4.5 9.5 13 9.5 3.4 0 7.5-.7 12.1-1.8 7-1.4 16.6-3.2 28.4-3.2 6.6 0 13.6.5 20.3 1.8 13.6 2.3 25 10.3 38.2 19.8 19.1 13.4 40.5 28.7 73.3 28.7.9 0 1.8 0 2.7-.2 1.1 0 2.5.2 3.9.2 32.8 0 54.2-15.2 73.3-28.7 13.4-9.5 24.8-17.5 38.2-19.8 7-1.1 13.7-1.8 20.3-1.8 11.4 0 20.3 1.4 28.4 3 5 1.1 9.1 1.4 12.1 1.4h.8c6.2 0 10.5-3.2 12.3-9.3 1.2-4.3 2.1-8.4 3-12.3.9-4.1 2.3-10.7 3.7-12.7 41.7-6.4 64.8-15.9 70.3-28.5.7-1.6 1.1-3.4 1.2-5 .4-5.7-3.7-10.7-9.3-11.6-72.6-12-105.3-86.5-106.5-89.6 0-.2-.2-.4-.2-.5-3.9-7.8-4.8-14.4-2.5-19.6 4.1-9.8 19.6-14.8 29.8-18 2.9-.9 5.5-1.8 7.7-2.7 18-7.1 27.1-15.9 26.9-26-.2-8-6.4-15.2-16.2-18.6-3.4-1.4-7.3-2.1-11.1-2.1-2.7 0-6.6.4-10.2 2.1-8.6 4.1-16.4 6.2-23 6.6-4.5-.2-7.3-1.2-8.9-2.3.2-3.7.4-7.5.7-11.4l.2-1.6c2.3-36.2 5.2-81.4-6.8-107.9-35.6-79-110.4-85-132.5-85m0 11c20.2 0 89.4 5.4 122 78.5 10.7 24.1 8 67.8 5.7 102.8-.4 5.5-.7 10.9-.9 16.1l-.2 2.1 1.4 1.6c.5.7 6.2 6.4 18.6 7h.4c8.2-.4 17.5-2.9 27.5-7.5 1.4-.7 3.4-1.1 5.5-1.1 2.3 0 4.8.5 7 1.2l.4.2c5.4 1.8 8.9 5.4 9.1 8.6 0 1.8-1.2 8.2-20 15.5-1.8.7-4.3 1.4-7 2.3-12.1 3.9-30.5 9.6-36.8 24.3-3.6 8.2-2.5 17.8 2.9 28.7 2.1 5.2 36.9 83.3 114.9 96.2 0 .4-.2.7-.4 1.3-1.2 3-9.8 13.9-62.1 21.9-8.2 1.2-10.2 10.5-12.5 21.1-.9 3.7-1.6 7.7-2.9 11.6-.4 1.2-.4 1.2-1.8 1.2h-.5c-2.3 0-5.9-.5-10-1.2-7.5-1.4-17.7-3.2-30.5-3.2-7.3 0-14.8.7-22.1 1.8-16.1 2.7-29.1 12-42.8 21.6-18.6 13-37.6 26.6-66.9 26.6-1.2 0-2.5 0-3.7-.2H496.3c-29.3 0-48.3-13.6-66.9-26.6-13.7-9.8-26.8-18.9-42.8-21.6-7.5-1.2-15-1.8-22.1-1.8-13 0-23.2 2-30.5 3.4-4.1.9-7.7 1.4-10 1.4-2 0-2-.2-2.3-1.4-1.2-3.9-2-8-2.9-11.8-2.3-10.7-4.3-20-12.5-21.2-52.3-8-60.7-18.9-62.1-21.9-.2-.5-.4-.9-.4-1.2 78.1-12.8 112.8-91 114.9-96.2 5.4-10.9 6.2-20.5 2.9-28.7-6.2-14.6-24.6-20.3-36.8-24.3-2.9-.9-5.2-1.6-7-2.3-15.7-6.2-20.7-12.5-20-16.2.9-4.5 8.4-8.9 15-8.9 1.4 0 2.9.2 3.7.7 10.7 5 20.7 7.7 29.3 7.7 13.6 0 19.6-6.2 20.3-7l1.4-1.6-.2-2.1c-.4-5.2-.5-10.5-.9-16.1-2.1-35.1-5-78.7 5.7-102.8 32.5-73 101.5-78.5 121.9-78.5h10.9'
            className='st2'
         ></path>
      </svg>
   );
}
const  FbIcon = () => {
   return (
      <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
         <g clip-path='url(#clip0_18204_2918)'>
            <path d='M20 10C20 4.47715 15.5229 0 10 0C4.47715 0 0 4.47715 0 10C0 14.9912 3.65684 19.1283 8.4375 19.8785V12.8906H5.89844V10H8.4375V7.79688C8.4375 5.29063 9.93047 3.90625 12.2146 3.90625C13.3084 3.90625 14.4531 4.10156 14.4531 4.10156V6.5625H13.1922C11.95 6.5625 11.5625 7.3334 11.5625 8.125V10H14.3359L13.8926 12.8906H11.5625V19.8785C16.3432 19.1283 20 14.9912 20 10Z' fill='url(#paint0_linear_18204_2918)' />
            <path d='M13.8926 12.8906L14.3359 10H11.5625V8.125C11.5625 7.33418 11.95 6.5625 13.1922 6.5625H14.4531V4.10156C14.4531 4.10156 13.3088 3.90625 12.2146 3.90625C9.93047 3.90625 8.4375 5.29063 8.4375 7.79688V10H5.89844V12.8906H8.4375V19.8785C9.47287 20.0405 10.5271 20.0405 11.5625 19.8785V12.8906H13.8926Z' fill='white' />
         </g>
         <defs>
            <linearGradient id='paint0_linear_18204_2918' x1='2.9965' y1='2.9783' x2='18.2142' y2='18.289' gradientUnits='userSpaceOnUse'>
               <stop stop-color='#2AA4F4' />
               <stop offset='1' stop-color='#007AD9' />
            </linearGradient>
            <clipPath id='clip0_18204_2918'>
               <rect width='20' height='20' fill='white' />
            </clipPath>
         </defs>
      </svg>
   );
}
const  TwitterIcon = () => {
   return (
      <>
         {/* <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <circle cx='10' cy='10' r='10' fill='#4DA1EC' />
            <path d='M8.01204 14.2857C12.0552 14.2857 14.2666 10.9877 14.2666 8.12773C14.2666 8.03404 14.2666 7.94082 14.2602 7.84797C14.6904 7.54161 15.0618 7.16222 15.3569 6.72775C14.9556 6.90275 14.53 7.01755 14.0943 7.06825C14.5531 6.7979 14.8967 6.37226 15.0607 5.87118C14.6293 6.1233 14.1572 6.30091 13.6649 6.39655C13.2492 5.96124 12.6687 5.71423 12.0621 5.71423C10.855 5.71423 9.86176 6.69212 9.86176 7.88054C9.86176 8.04539 9.88085 8.20978 9.91874 8.37036C8.15218 8.28319 6.50401 7.46049 5.38832 6.10916C4.80813 7.09244 5.10834 8.36673 6.06887 8.99825C5.71905 8.98801 5.3768 8.89517 5.0712 8.72733V8.75478C5.07149 9.78113 5.81298 10.6731 6.83474 10.8763C6.5111 10.9632 6.17149 10.9759 5.84218 10.9135C6.12944 11.7929 6.95777 12.3991 7.89591 12.4164C7.11766 13.0186 6.15571 13.3456 5.16589 13.3447C4.99098 13.3443 4.81626 13.3339 4.64258 13.3135C5.64771 13.9485 6.81764 14.2855 8.01204 14.284' fill='white' />
         </svg> */}
         <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fill-rule='evenodd' clip-rule='evenodd' d='M9.49233 12.31L2 3H7.93446L12.5594 8.75425L17.5004 3.02591H20.7688L14.1397 10.7204L22 20.5H16.0833L11.0754 14.2771L5.72896 20.4827H2.44287L9.49233 12.31ZM16.9457 18.775L5.63881 4.72499H7.07138L18.364 18.775H16.9457Z' fill={ window.site_dark_bg ? '#FFFFFF' : '#1C1C1C' } />
         </svg>

      </>
   );
}
// const  SharesomeIcon = () => {
//    return (
//       <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
//          <g clip-path='url(#clip0_18204_2966)'>
//             <path d='M15.9272 2.22701L9.7092 0C4.43974 0.0374917 0.180675 4.31905 0.180675 9.59788C0.177073 12.033 1.10302 14.3777 2.76948 16.1533L11.595 19.0233C16.0284 18.1741 19.3764 14.2769 19.3764 9.59788C19.3764 6.63604 18.0342 3.98725 15.9272 2.22701Z' fill='#F14472' />
//             <path d='M12.5206 5.09139C12.8149 5.79624 13.6435 6.1018 14.0709 6.1018C15.4337 6.1018 16.2361 4.94143 16.2361 3.62734C16.2355 3.14369 16.13 2.66592 15.9268 2.22703C15.8349 2.15204 15.7431 2.07706 15.6493 2.00395L10.3911 0.230591C7.93728 0.770472 6.27077 2.62444 6.27077 4.99017C6.27077 9.63539 11.6133 10.1903 11.6133 14.2544C11.6133 16.1215 10.5711 17.7617 8.37968 17.7617C6.53696 17.7617 5.5753 16.4233 5.5753 15.0867C5.5753 13.647 6.88376 12.5373 8.64774 13.0921C8.78084 12.7903 8.8352 12.5373 8.67399 12.2861C8.67399 11.3263 7.79293 10.7227 6.91188 10.7227C4.13374 10.7227 2.66406 12.766 2.66406 14.9124C2.66423 15.342 2.72288 15.7695 2.8384 16.1833L9.88122 19.1958C10.4569 19.1891 11.0309 19.1314 11.5965 19.0233C13.7579 18.071 15.1676 16.159 15.1676 13.497C15.1676 9.1555 9.58504 8.14697 9.58504 4.53652C9.58504 2.9225 10.438 1.48281 12.0951 1.48281C13.218 1.48281 13.726 2.26452 13.726 3.09871C13.726 3.9329 13.3773 4.83833 12.5206 5.09139Z' fill='#A93050' />
//             <path d='M9.70892 1.0979e-05C7.45567 0.637371 5.95038 2.42198 5.95038 4.66961C5.95038 9.31483 11.2929 9.86971 11.2929 13.9338C11.2929 15.8009 10.2526 17.4412 8.06116 17.4412C6.21657 17.4412 5.25678 16.1027 5.25678 14.7661C5.25678 13.3265 6.56524 12.2167 8.32735 12.7734C8.46045 12.4698 8.51481 12.2167 8.51481 11.9655C8.51481 11.0076 7.63375 10.4021 6.75082 10.4021C3.97269 10.4021 2.50488 12.4454 2.50488 14.5918C2.50442 15.1241 2.59378 15.6526 2.7692 16.1552C4.52007 18.026 7.01327 19.1958 9.77828 19.1958H9.88138C12.8995 18.5697 15.0084 16.4326 15.0084 13.1784C15.0084 8.83494 9.42399 7.82641 9.42399 4.21783C9.42399 2.60194 10.2788 1.16225 11.9359 1.16225C13.0569 1.16225 13.5668 1.94583 13.5668 2.77815C13.5668 3.61047 13.0569 4.51777 12.2021 4.77083C12.4964 5.47755 13.3231 5.78124 13.7524 5.78124C15.1152 5.78124 15.9157 4.62087 15.9157 3.30678C15.9148 2.85909 15.8243 2.4161 15.6495 2.00394C13.9696 0.70191 11.9037 -0.00320894 9.77828 1.0979e-05H9.70892Z' fill='white' />
//          </g>
//          <defs>
//             <clipPath id='clip0_18204_2966'>
//                <rect width='20' height='20' fill='white' />
//             </clipPath>
//          </defs>
//       </svg>
//    );
// }

const SocialLinks = ({
   onClick,
   onCopy,
   id,
   type,
   isHomepage,
   isGlobalRoute,
}) => {

   let url = '';
   let prefix = window.location.origin;
   if(window.location.pathname !== '/'){
      prefix = `${ window.location.origin }${ window.location.pathname }`;
   }
   if(Boolean(isHomepage && window.location.pathname !== '/')) {
      if(type === 'story') {
         url = `${ prefix }/stories/${ id }`
      }
      else if(type === 'store') {
         url = `${ prefix }/${ type }/${ id }`
      }
      else if(type === 'livestream') {
         url = `${ prefix }/recorded-streams/${ id }`
      }
      else {
         url = `${ prefix }/${ type }s/${ id }`
      }
   }
   else if(window.location.pathname !== '/' && Boolean(isGlobalRoute)) {
      url += `${ prefix }/${ id }`
   }
   else if(window.location.pathname !== '/' && !Boolean(isGlobalRoute)) {
      url += `${ prefix }`
   } else {
      if(type === 'story') {
         url = `${ prefix }/stories/${ id }`
      }
      else if(type === 'store') {
         url = `${ prefix }/${ type }/${ id }`
      }
      else if(type === 'livestream') {
         url = `${ prefix }/recorded-streams/${ id }`
      }
      else {
         url += `${ prefix }/${ type }s/${ id }`
      }
   }

   const [contentData, setContentData] = useState(null)
   const { siteInfo: { site_long_name, owner_twitter_nickname }  } = useSelector(state => state.common)

   const getContentData = () => {
      let result

      switch (type) {
         case 'story':
            result = getStoryById(id)
            break;
         case 'photoset':
            result = getPhotosetById(id)
            break;
         case 'video':
            result = getVideoById(id)
            break;
         case 'livestream':
            result = getVideoById(id, '?video_type=livestream')
            break;
         case 'store':
            result = initStoreById(id)
            break;

         default:
            break;
      }
      if(result?.then){
         result
            .then(res => {
               setContentData(res?.data)
            })
            .catch(err => {
               console.log(err);
            })
      } else {
         setContentData({});
      }
   }

   useEffect(() => {
      getContentData()
      return () => {
         setContentData(null)
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   const tweetUrl = makeTweetableUrl('',
      `I'm enjoying ${ type === 'store' ? contentData?.name : (!contentData?.title ? 'a ' + type : contentData?.title) } on ${ site_long_name || '' }${ !!owner_twitter_nickname ? ` by @${ owner_twitter_nickname }` : `` }. Check it out! ${ url }  ${ getNickName() }`);
   const fbShareUrl = makeFbShareUrl(url);
   const snapShareUrl = makeSnapShareUrl(url)
   // const shareSomeUrl = makeShareSomeShareUrl(url)


   const shareTo = (url, siteName) => {
      window.open(
         url,
         `${ siteName }window`,
         "height=550, width=550, toolbar=0, location=0, menubar=0, directories=0,scrollbars=0"
      );
   }

   const shareLinks = [
      {
         id: 1,
         title: 'Facebook',
         iconName: <FbIcon />,
         action: () => shareTo(fbShareUrl, 'facebook'),
      },
      // {  id: 2,
      //    title: 'Instagram',
      //    iconName: igIcon,
      //    action: () => {},
      // },
      {
         id: 3,
         title: 'X',
         iconName: <TwitterIcon />,
         action: () => shareTo(tweetUrl, 'twitter'),
      },
      // {
      //    id: 4,
      //    title: 'Sharesome',
      //    iconName: <SharesomeIcon />,
      //    action: () => shareTo(shareSomeUrl, 'sharesome'),
      // },
      {
         id: 5,
         title: 'Snapchat',
         iconName: <SnapchatIcon />,
         action: () => shareTo(snapShareUrl, 'snapchat'),
      },
      // {  id: 6,
      //    title: 'TikTok',
      //    iconName: tiktokIcon,
      //    action: () => {},
      // },
   ]

   return (
      <div className='overflow-hidden '>
         <div className='h-14 flex items-center sticky top-0 border-b border-divider dark:border-divider-dark'>
            <Button
               iconName='close'
               alignment='end'
               iconSize={ 5 }
               classNames='!w-[44px]'
               waveActive={ false }
               primaryColor={ false }
               backgroundColor='transparent'
               fontIconColor='major'
               textColor='major dark:text-major-dark'
               textPosition='right'
               // text='Share'
               iconPosition='left'
               verticalAlignment='end'
               textMarginX='4'
               fontWeight='bold'
               textSize='extraLarge'
               onClick={ onClick }
               textClassName='group-hover:!no-underline'
            />
            <p className='text-major dark:text-major-dark py-3 font-bold text-xl hover:cursor-default select-none'>
               Share
            </p>
         </div>
         {
            !contentData ?
               <div className='h-[208px] flex items-center justify-center'>
                  <Loader color='primary' />
               </div>
               :
               <div
                  className=' grid grid-cols-2 gap-x-4 gap-y-3 p-5  overflow-hidden text-secondary dark:text-secondary-dark'
               >
                  {
                     <>
                        <button
                           onClick={ () => {
                              onCopy()
                              onClick()
                           } } className='w-auto h-12 p-3 flex items-center justify-start
                                border-2 border-solid text-sm dark:border-divider-dark
                                gap-3 rounded-lg flex-auto font border-divider
                                hover:bg-hover dark:hover:bg-hover-dark focus:outline-none
                                social-btn
                                ' >
                           <Icon name='copy' size='xl'
                              color='secondary'
                              darkColor='secondary-dark'
                           />
                           <p className='dark:text-grey-link text-base social-text text-secondary dark:text-secondary-dark'>Copy link</p>
                        </button>
                        <button onClick={ () => {
                           window.open(`mailto:?body=${ url }&subject=`)
                        } } className='w-auto h-12 p-3 flex items-center justify-start
                                border-2 border-solid text-sm dark:border-divider-dark
                                gap-3 rounded-lg flex-auto cursor-pointer
                                focus:outline-none border-divider
                                hover:bg-hover dark:hover:bg-hover-dark
                                social-btn
                                '>
                           <Icon name='message' size='xl'
                              color='secondary'
                              darkColor='secondary-dark'
                           />
                           <p className='dark:text-grey-link text-base social-text text-secondary dark:text-secondary-dark'>Email</p>
                        </button>

                     </>
                  }
                  {
                     shareLinks && shareLinks.map((link) => {
                        return <React.Fragment key={ link.id }>
                           <button onClick={ link.action } className='w-auto h-12 p-3 flex items-center justify-start
                                border-2 border-solid dark:border-divider-dark  text-sm
                                gap-3 rounded-lg flex-auto cursor-pointer
                                hover:bg-hover dark:hover:bg-hover-dark focus:outline-none
                                social-btn border-divider
                                '>
                              <div alt='' className='h-5 w-5'>
                                 {link.iconName}
                              </div>
                              <p className='dark:text-grey-link text-base social-text text-secondary dark:text-secondary-dark '>{link.title}</p>
                           </button>
                        </React.Fragment>
                     })
                  }
               </div>
         }
      </div>
   )
};

SocialLinks.propTypes = {
   onClick: PropTypes.func,
   onCopy: PropTypes.func,
   id: PropTypes.number,
   type: PropTypes.string,
   isHomepage: PropTypes.bool,
   isGlobalRoute: PropTypes.bool,
};

export default React.memo(SocialLinks);
